// The PDF viewer's version: the one version of this artefact. It is
// recorded in asset-manifest.json, reported to the tracking endpoint as
// appVersion, and exported by the reader module. It must equal
// package.json's "version"; the build and version.unit.js check that.
export const VERSION = "1.0.0";
